import { ArrowLeft, AlertCircle, Clock, DollarSign, CheckCircle } from 'lucide-react';

interface CancellationPolicyScreenProps {
  onBack: () => void;
}

export const CancellationPolicyScreen = ({ onBack }: CancellationPolicyScreenProps) => {
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Políticas de cancelación</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4 pb-8">
        {/* Alert Banner */}
        <div className="bg-[#FFF4ED] rounded-[12px] border border-[#FFE4D6] p-4 flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-[#FF6A2A] flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-[#111827] mb-1">
              Importante
            </p>
            <p className="text-xs text-[#6B7280]">
              Las políticas de cancelación pueden variar según la línea de autobús y el tipo de boleto.
            </p>
          </div>
        </div>

        {/* Refund Timeline */}
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] overflow-hidden">
          <div className="p-4 border-b border-[#E5E7EB]">
            <h2 className="font-bold text-[#111827]">Reembolsos por cancelación</h2>
          </div>
          <div className="divide-y divide-[#E5E7EB]">
            <div className="p-4 flex items-start gap-3">
              <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0">
                <CheckCircle className="w-5 h-5 text-green-600" />
              </div>
              <div>
                <p className="font-semibold text-[#111827] mb-1">
                  Más de 24 horas antes
                </p>
                <p className="text-sm text-[#6B7280]">
                  Reembolso del 100% del costo del boleto
                </p>
              </div>
            </div>
            <div className="p-4 flex items-start gap-3">
              <div className="w-10 h-10 bg-[#FFF4ED] rounded-full flex items-center justify-center flex-shrink-0">
                <Clock className="w-5 h-5 text-[#FF6A2A]" />
              </div>
              <div>
                <p className="font-semibold text-[#111827] mb-1">
                  Entre 24 y 2 horas antes
                </p>
                <p className="text-sm text-[#6B7280]">
                  Reembolso del 50% del costo del boleto
                </p>
              </div>
            </div>
            <div className="p-4 flex items-start gap-3">
              <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center flex-shrink-0">
                <AlertCircle className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <p className="font-semibold text-[#111827] mb-1">
                  Menos de 2 horas antes
                </p>
                <p className="text-sm text-[#6B7280]">
                  No hay reembolso disponible
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] overflow-hidden">
          <div className="p-4 border-b border-[#E5E7EB]">
            <h2 className="font-bold text-[#111827]">Información adicional</h2>
          </div>
          <div className="p-4 space-y-4">
            <div className="flex items-start gap-3">
              <DollarSign className="w-5 h-5 text-[#6B7280] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-[#111827] mb-1">
                  Tiempo de procesamiento
                </p>
                <p className="text-sm text-[#6B7280]">
                  Los reembolsos se procesan en un plazo de 5 a 7 días hábiles a tu método de pago original.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-[#6B7280] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-[#111827] mb-1">
                  Cambios de fecha
                </p>
                <p className="text-sm text-[#6B7280]">
                  Puedes cambiar la fecha de tu viaje sin costo adicional hasta 24 horas antes de la salida, sujeto a disponibilidad.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <AlertCircle className="w-5 h-5 text-[#6B7280] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-[#111827] mb-1">
                  Casos especiales
                </p>
                <p className="text-sm text-[#6B7280]">
                  En caso de cancelación por parte de la línea de autobús o fuerza mayor, se reembolsará el 100% del costo del boleto.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
